var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-layout',{staticClass:"marginTop",attrs:{"md-flex":"100"}},[_c('md-card',[_c('div',{staticClass:"errorContainer"},[_c('h3',[_vm._v("You do not have permission to view that page.")]),_vm._v(" "),_c('router-link',{staticClass:"md-button",attrs:{"to":"/"}},[_c('md-icon',[_vm._v("keyboard_return")]),_vm._v(" Home\n            ")],1)],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01d56687","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/error/ErrorPermission.vue
// module id = 812
// module chunks = 0